var map = {
	"./android/DeviceSetup": 1331,
	"./androidtv/DeviceSetup": 1332,
	"./arris/DeviceSetup": 1333,
	"./hisense/DeviceSetup": 1334,
	"./lg/DeviceSetup": 1335,
	"./nagra/DeviceSetup": 1337,
	"./netrange/DeviceSetup": 1338,
	"./opera/DeviceSetup": 1339,
	"./polaroid/DeviceSetup": 1340,
	"./ps4/DeviceSetup": 1341,
	"./samsung/DeviceSetup": 1342,
	"./seirobotics/DeviceSetup": 1343,
	"./sony/DeviceSetup": 1344,
	"./stbcoship/DeviceSetup": 1345,
	"./stbcoship9108/DeviceSetup": 1346,
	"./stbhuawei/DeviceSetup": 1347,
	"./stbkaon/DeviceSetup": 1348,
	"./tizen/DeviceSetup": 1349,
	"./web0s/DeviceSetup": 1350,
	"./workstation/DeviceSetup": 1352,
	"./workstationChafari/DeviceSetup": 1353,
	"./zeasn/DeviceSetup": 1354,
	"./zte/DeviceSetup": 1355
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1330;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/DeviceSetup$
// module id = 1330
// module chunks = 0